import React from 'react';
import { pluralText } from '../../utilities/wordUtilities';

class ArchivePagesAndFoldersModal extends React.Component {

    state = {
        buttonDisabled: false,
    };

    handleArchive = () => {
        if (!this.state.buttonDisabled) {
            this.props.handleArchive();
            this.setState({ buttonDisabled: true });
        }
    };

    render() {
        const { buttonDisabled } = this.state;
        const {
            pagesCount, foldersCount, suggestionsCount, externalResourcesCount, documentsCount, questionsCount,
        } = this.props;

        const itemsCount = pagesCount + suggestionsCount + externalResourcesCount + documentsCount + questionsCount;
        const warningText = itemsCount && foldersCount
            ? `archive ${pluralText(itemsCount, 'item')} and delete ${pluralText(foldersCount, 'subcategory', true)}`
            : itemsCount
                ? `archive ${pluralText(itemsCount, 'item')}`
                : `delete ${pluralText(foldersCount, 'subcategory')}`;
        const buttonText = buttonDisabled ? 'Archiving...' : 'Archive';
        const buttonClass = buttonDisabled ? 'btn btn-primary bg-red is-disabled' : 'btn btn-primary bg-reg';

        return (
            <div className="react-modal open move-page-modal">
                <div className="modal-content">
                    <h3>Archive</h3>
                    <div className="mb3" style={{ color: '#555459' }}>
                        <p>
Are you sure you want to&nbsp;
                            <b>
                                {warningText}
                                {foldersCount ? ' (and contained items)' : ''}
                            </b>
?
                        </p>
                        {foldersCount > 0
                            && (
                                <ul>
                                    <li>Selected pages and external links will be uncategorized and archived.</li>
                                    <li>Suggestions will be uncategorized and closed.</li>
                                    <li>Any contained subcategories will be deleted.</li>
                                </ul>
                            )}
                    </div>
                    <div className="right-align">
                        <span className="btn-secondary mr1" onMouseDown={this.props.closeModal}>Close</span>
                        <span className={buttonClass} onMouseDown={this.handleArchive}>{buttonText}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default ArchivePagesAndFoldersModal;
